import './EventItem.scss';
import EventItemProps from './EventItemProps';
import moment from 'moment';
import {useNavigate } from 'react-router-dom';

const EventsItem = (props: EventItemProps) => {
    const navigate = useNavigate();
    const { userclass } = props;
   
    const goTo = (path: string, id: string) => {
        navigate(path + id);
    }


    return (
        <div className="event-item py-2 px-2" onClick={() => goTo('/my-campus/event/timeline/', userclass.eventId)}>
            <div className="date-wrapper">
                <div className="day">{moment(userclass.startDate).format('DD')}</div>
                <div className="month">{moment(userclass.startDate).format('MMM')}</div>
            </div>
            <div className="details px-2">
                <div className="event-title" >{userclass.sessionTitle}</div>
                <div className="event-type">{userclass.sessionType}</div>
            </div>
        </div>
    )
}

export default EventsItem;